import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { Global } from 'src/app/Global';
import { CommonService } from 'src/app/services/common.service';
import { ResumeService } from 'src/app/services/resume.service';
import { AlertService } from 'src/app/common/alert.service';

@Component({
  selector: 'app-my-resume',
  templateUrl: './my-resume.component.html',
  styleUrls: ['./my-resume.component.css']
})
export class MyResumeComponent implements OnInit {

  ResumeRecordsForm: FormGroup;
  displayedColumns = ['ResumeId', 'EmployeeLPN', 'EmployeeGPN', 'EmployeeName', 'EmployeeEmail', 'Status'];
  ResumeDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  recordsExists: boolean = false;
  constructor(private _fb: FormBuilder, private _router: Router, public _global: Global,
    public _commonService: CommonService, private error: AppErrorHandler,
    private _resumeService: ResumeService, injector: Injector, public _alertService: AlertService,
    private status: HTTPStatus) { }

  ngOnInit() {
    //   this.paginator.showFirstLastButtons = true;

    this.ResumeRecordsForm = this._fb.group({
      ResumeId: [],
      EmployeeLPN: [],
      EmployeeGPN: [],
      EmployeeName: [],
      EmployeeEmail: [],
      Status: [],
      StatusDesc: []
    });
    this.LoadAllMyResumeList();
  }



  LoadAllMyResumeList() {
    this.status.setHttpStatus(true);
    this._resumeService.GetMyResumeList(this.ResumeRecordsForm.value).subscribe(data => {
      if (data != null) {
        if (data.length > 0) {
          this.recordsExists = true;
        }
        this.ResumeDataSource = new MatTableDataSource(data);
        this._global.length = data.TotalRecordCount;
        if (this._global.length === 0) {
          this.ResumeDataSource = null;

        } else {
          this.status.setHttpStatus(false);
        }
      } else {
        this.ResumeDataSource = new MatTableDataSource(data);
        this._global.length = data.TotalRecordCount;
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => { this.status.setHttpStatus(false); });
  }

  ShowDetails(row: any) {
    this._router.navigate(['/home/resume'], { queryParams: { param1: this._commonService.EncryptData(row.ResumeId) } });
    //this._router.navigate(['/home/resume',this._commonService.EncryptData(row.ResumeId)]);
  }


}
